<!--
@component
Spinner

See markup below.
-->

<script lang="ts">
  import { Block } from '@reuters-graphics/graphics-components';
  import { footballIcon as football } from './footballIcon';

  type Props = {
    /** Diameter of the spinner in px */
    size?: number;
    /** Accessible label for screen readers */
    label?: string;
    /** Extra class on the outer Block */
    class?: string;
  };

  const {
    size = 50,
    label = 'Loading…',
    class: className = 'fmy-9',
  }: Props = $props();
</script>

<Block class={className}>
  <div
    class="loader mx-auto"
    role="status"
    aria-live="polite"
    style:--spinner-size="{size}px"
    style:--spinner-image="url({football})"
  >
    <span class="visually-hidden">{label}</span>
  </div>
</Block>

<style lang="scss">
  /* Reference https://css-loaders.com/wobbling/ */
  .loader {
    z-index: 1000;
    position: relative;
    width: var(--spinner-size, 50px);
    aspect-ratio: 1;
    display: grid;
    transform: translateY(100%);
  }

  .loader::before,
  .loader::after {
    content: '';
    grid-area: 1/1;
    border-radius: 50%;
    transform-origin: bottom;
    position: relative;
  }

  .loader::before {
    background: var(--spinner-image) center / contain no-repeat;
    transform: scaleY(0.65);
    top: 0;
    animation:
      l11-1 1.3s cubic-bezier(0, 400, 1, 400) infinite,
      l11-2 1.3s ease infinite;
  }

  .loader::after {
    background: var(--theme-colour-mid-grey);
    filter: blur(8px);
    transform: scaleY(0.3) translate(0, 0);
    left: 0;
    animation: l11-3 1.3s cubic-bezier(0, 400, 1, 400) infinite;
  }

  @keyframes l11-1 {
    100% {
      top: -0.2px;
    }
  }
  @keyframes l11-2 {
    4%,
    96% {
      transform: scaleY(1);
    }
  }
  @keyframes l11-3 {
    100% {
      transform: scaleY(0.3) translate(0.1px, -0.1px);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .loader::before,
    .loader::after {
      animation: none;
    }
  }
</style>
